export const DEFAULT_CLICK_TRACKING_SUBDOMAIN = 'click';

// RFC 1035 label: lowercase letters, digits, and hyphens; 1-63 chars; cannot start or end with a hyphen.
export const CLICK_TRACKING_SUBDOMAIN_REGEX = /^[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?$/;
